import { EnvironmentProviders, Provider } from '@angular/core';

import { provideBingoHost } from '../host-app-provide';
import { HtmlBootstrapService } from '../html/html-bootstrap.service';
import { BingoAppLazyBootstrapService } from './bootstrap/bingo-app-lazy-bootstrap.service';
import { runOnBingoAppInit } from './run-on-bingo-app.provider';

export function provideBingoAppBootstrap(): (Provider | EnvironmentProviders)[] {
    return [runOnBingoAppInit(HtmlBootstrapService), provideBingoHost(), BingoAppLazyBootstrapService];
}
